import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { City, CreateOrUpdateCity } from "../../survey/models/City";
import { OsmData } from "../models/OsmData";

export const CityApi = {
  get: async (id: string) => {
    return await jwtAuthAxios().get<City>(`/cities/${id}`);
  },

  getOsmData: async (id: string) => {
    return await jwtAuthAxios().get<OsmData>(`/cities/${id}/osm-data`);
  },

  search: async (name: string, country: string) => {
    const params = new URLSearchParams({
      name,
      country,
    });

    return await jwtAuthAxios().get<City[]>(
      `/cities/search?${params.toString()}`,
    );
  },

  create: async (body: CreateOrUpdateCity) => {
    return await jwtAuthAxios().post<City>(`/cities`, body);
  },
};
